export default function(store) {
  return store.getters['auth/IS_AUTH'] && (store.getters['auth/ROLE_NAME'] == 'dashboard');
};